import { navbarIcons } from "helpers/images";
import React from "react";
import classess from "./styles.module.scss";

export const AuthLayout = ({ children }) => {
  return (
    <div className="container-fluid p-0">
      <div className={`${classess.authLayout} row g-0 min-vh-100`}>
        {/* Left Side: Original Yellow Thangamayil Logo Background */}
        <div
          className={`${classess.authBackground} col-lg-6 col-12 d-flex justify-content-center align-items-center`}
        >
          <img src={navbarIcons.logo} className="img-fluid" alt="logo" />
        </div>

        {/* Right Side: Clean Form Container */}
        <div
          className={`${classess.authContentBackground} col-lg-6 col-12 d-flex justify-content-center align-items-center p-3 p-md-4`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
